import { useTranslation } from 'react-i18next';

import type { MessageFieldProps } from '@/types/predefined-messages';

import { FieldLabel } from '@/components/ui/field';
import { Input } from '@/components/ui/input';

export function MessageField({ register, messageError }: MessageFieldProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <FieldLabel htmlFor="predefined-message-text" className="text-sm font-medium" required>
        {t('configuration.predefinedMessages.columns.message')}
      </FieldLabel>
      <Input
        id="predefined-message-text"
        placeholder={t('configuration.predefinedMessages.form.messagePlaceholder')}
        aria-invalid={messageError ? 'true' : undefined}
        {...register('message', { required: true })}
      />
    </div>
  );
}
